<template>
  <div style="margin: 0 32px 32px;">
    <el-descriptions title="客户信息" border :column="2" size="small">
      <template #extra>
        <el-button type="primary" size="small" @click="editUserDialog(1,userInfo)">编辑</el-button>
      </template>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="主人" >{{ userInfo.name }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" >{{ userInfo.sex == 1?'男':userInfo.sex == 2?'女':'未知' }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机号" >{{ userInfo.phone }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店" >{{ userInfo.shopName}}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="描述" :span="2"><span v-if="userInfo.userPerfect">{{userInfo.userPerfect.userDesc}}</span></el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="图片" :span="2">
        <el-space wrap>
          <div class="img-box" v-for="(item, index) in userInfo.userImgList" :key="item.id"  @click="showImg(index, userInfo.userImgList)" style="cursor: pointer;">
            <el-image style="width: 40px; height: 40px;" fit="cover" :src="item.img" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
        </el-space>
      </el-descriptions-item>
<!--      <div v-if="userInfo.userWallet">-->
<!--        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="总余额" :span="2">{{ userInfo.userWallet.balanceOne + userInfo.userWallet.balanceTwo + userInfo.userWallet.balanceThree + userInfo.userWallet.balanceFour}}</el-descriptions-item>-->
<!--        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="500账户">{{ userInfo.userWallet.balanceOne}}</el-descriptions-item>-->
<!--        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1000账户">{{ userInfo.userWallet.balanceTwo}}</el-descriptions-item>-->
<!--        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1500账户">{{ userInfo.userWallet.balanceThree}}</el-descriptions-item>-->
<!--        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="2500账户">{{ userInfo.userWallet.balanceFour}}</el-descriptions-item>-->
<!--        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="宠物信息" :span="2"><p v-for="(item, index) of userInfo.petList" :key="item.id">{{index + 1}}、{{item.name}}&nbsp;-&nbsp;{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月 </p></el-descriptions-item>-->
<!--      </div>-->

    </el-descriptions>
    <el-descriptions title="总余额" border :column="2" size="small" style="margin-top: 24px;">
      <template #title>
        <p>总余额：<span v-if="userInfo.userWallet" style="color: #3a8ee6">{{ userInfo.userWallet.balanceSumAll}}<span class="giveFont" v-if="userInfo.userWallet.balanceSumAll">（{{userInfo.userWallet.balanceSum}} + {{userInfo.userWallet.balanceSumGive}}）</span></span></p>
      </template>
      <template #extra>
        <el-button type="danger" size="small" @click="openDialog">充值</el-button>
      </template>
<!--      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="主人" :span="2">{{ userInfo.name }}</el-descriptions-item>-->
<!--      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" :span="2">{{ userInfo.sex == 1?'男':userInfo.sex == 2?'女':'未知' }}</el-descriptions-item>-->
<!--      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机号" :span="2">{{ userInfo.phone }}</el-descriptions-item>-->
<!--      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店" :span="2">{{ userInfo.shopName}}</el-descriptions-item>-->
      <div v-if="userInfo.userWallet">
<!--        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="总余额" :span="2">{{ userInfo.userWallet.balanceOne + userInfo.userWallet.balanceTwo + userInfo.userWallet.balanceThree + userInfo.userWallet.balanceFour}}</el-descriptions-item>-->
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="500账户">{{ userInfo.userWallet.balanceSumOne}}<span class="giveFont" v-if="userInfo.userWallet.balanceSumOne">（{{ userInfo.userWallet.balanceOne}} + {{userInfo.userWallet.balanceOneGive}}）</span></el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1000账户">{{ userInfo.userWallet.balanceSumTwo}}<span class="giveFont"  v-if="userInfo.userWallet.balanceSumTwo">（{{ userInfo.userWallet.balanceTwo}} + {{userInfo.userWallet.balanceTwoGive}}）</span></el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1500账户">{{ userInfo.userWallet.balanceSumThree}}<span class="giveFont"  v-if="userInfo.userWallet.balanceSumThree">（{{ userInfo.userWallet.balanceThree}} + {{userInfo.userWallet.balanceThreeGive}}）</span></el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="2500账户">{{ userInfo.userWallet.balanceSumFour}}<span class="giveFont"  v-if="userInfo.userWallet.balanceSumFour">（{{ userInfo.userWallet.balanceFour}} + {{userInfo.userWallet.balanceFourGive}}）</span></el-descriptions-item>
<!--        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="宠物信息" :span="2"><p v-for="(item, index) of userInfo.petList" :key="item.id">{{index + 1}}、{{item.name}}&nbsp;-&nbsp;{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月 </p></el-descriptions-item>-->
      </div>

    </el-descriptions>

    <div style="margin-top: 24px; display: flex; justify-content: space-between">
      <div>
        <p class="title">医疗金余额：
          <span v-if="userInfo.userWallet" style="color: #3a8ee6">{{userInfo.userWallet.medicalBenefit}}</span>
<!--          <span v-if="userInfo.userWallet && userInfo.userWallet.disableMedicalBenefit>0" class="giveFont" >（{{userInfo.userWallet.disableMedicalBenefit}}）</span>-->
        </p>
      </div>
      <div style="color: #409eff; cursor: pointer;" @click="openMedicalLis">查看</div>
    </div>

    <div style="margin-top: 24px;" v-if="userInfo.petList && userInfo.petList.length > 0" @click="petListDialog(userInfo)" class="cursor">
      <p class="title">宠物信息</p>
      <div class="content-box">
        <div style="margin: 12px 0;" v-for="(item, index) of userInfo.petList" :key="item.id">
          <span>{{index + 1}}、{{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}  </span>
          <span v-if="item.exemptionDesc" style="color: red; font-size: 12px; margin-left: 8px">*{{item.exemptionDesc}}</span>
        </div>

      </div>
    </div>

    <div style="margin-top: 24px;"  v-if="(userInfo.projectGiveList && userInfo.projectGiveList.length > 0) || (userInfo.projectGiveUsedList && userInfo.projectGiveUsedList.length > 0)">
      <div style="display: flex; align-items: center; justify-content: space-between; line-height: 1">
        <p class="title">赠送项目</p>
        <div style="color: #409eff; cursor: pointer;" @click="projectGiveList">查看</div>
      </div>

      <div class="content-box">
        <div style="margin: 12px 0;">
          <div v-if="userInfo.projectGiveList && userInfo.projectGiveList.length > 0">
            <p style="margin-bottom: 8px;color: #aaaaaa">未使用项目</p>
            <el-space wrap>
              <el-tag type="primary" effect="plain" v-for="(item, index) of userInfo.projectGiveList" :key="item.id">{{item.name + ' x ' + item.num}}</el-tag>
            </el-space>
          </div>
          <div v-if="userInfo.projectGiveUsedList && userInfo.projectGiveUsedList.length > 0">
            <p style="margin: 16px 0 8px;color: #aaaaaa">已使用项目</p>
            <el-space wrap >
              <el-tag type="info" effect="plain" v-for="(item, index) of userInfo.projectGiveUsedList" :key="item.id">{{item.name + ' x ' + item.num}}</el-tag>
            </el-space>
          </div>
        </div>

      </div>
    </div>

    <div style="margin-top: 24px;" v-if="userInfo.userConsumeAbduceList && userInfo.userConsumeAbduceList.length > 0" class="cursor" @click="consumeListDialog()">
      <p class="title">消费单</p>
      <div class="content-box">
        <ConsumeList :payList="userInfo.userConsumeAbduceList" />
        <p style="color: #409eff; margin-bottom: 8px" v-if="userInfo.userConsumeAbduceList && userInfo.userConsumeAbduceList.length >= 3">查看更多</p>
      </div>
    </div>
    <div style="margin-top: 24px;">
      <p class="title">备注信息</p>
      <div class="content-box" @click="editUserLog" style="cursor: pointer">
        <UserRemark v-if="showUserRemark" :userRemarkList="userInfo.userRemarkList" />
        <div v-else style="display: flex; justify-content: center; align-items: center;padding: 24px 0;">
          <ElIcons name="Plus" color="#aaaaaa"/>
          <span style="color: #bbbbbb; margin-left: 8px;">添加备注</span>
        </div>
        <p style="color: #409eff; margin-bottom: 8px" v-if="userInfo.userRemarkList && userInfo.userRemarkList.length >= 3">查看更多</p>
      </div>
    </div>
  </div>
</template>

<script>
import {getUserInfo} from "@/api/url"
import {getFormData, postFormData} from "@/api/api";
import Dialog from "@/assets/js/dialog"
import UserRemark from "@/components/Remark/UserRemark";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import UserDialog from "@/views/user/components/UserDialog";
import {decimal_NUM, add} from "@/assets/shared/util";
import ConsumeList from "@/views/user/components/ConsumeList";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import PetListDialog from "@/views/user/components/PetListDialog";
import ConsumeListDialog from "@/views/user/components/ConsumeListDialog";
import ImgViewer from "@/assets/js/imageViewer";
import payListDialog from "@/views/user/components/payListDialog";
import projectGiveListDialog from "@/views/user/components/projectGiveListDialog";
import medicalListDialog from "@/views/user/components/medical/medicalListDialog";
import PayDeductionListDialog from "@/views/user/components/PayDeductionListDialog";

export default {
name: "userInfoDialog",
  props: {
    value: Object
  },
  components: { UserRemark, ConsumeList },
  data() {
    return {
      userId: this.value.userId,
      userInfo: {},
      showUserRemark: false,
    }
  },
  methods: {

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i<list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },

    getPage() {
      let param = {};
      param['id'] = this.userId;
      getFormData(getUserInfo, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.userInfo = data.data
          this.userInfo.userWallet.balanceSum = add([this.userInfo.userWallet.balanceOne, this.userInfo.userWallet.balanceTwo, this.userInfo.userWallet.balanceThree, this.userInfo.userWallet.balanceFour])
          this.userInfo.userWallet.balanceSumGive = add([this.userInfo.userWallet.balanceOneGive, this.userInfo.userWallet.balanceTwoGive, this.userInfo.userWallet.balanceThreeGive, this.userInfo.userWallet.balanceFourGive])
          this.userInfo.userWallet.balanceSumAll = add([this.userInfo.userWallet.balanceSum, this.userInfo.userWallet.balanceSumGive])
          this.userInfo.userWallet.balanceSumOne = add([this.userInfo.userWallet.balanceOne, this.userInfo.userWallet.balanceOneGive])
          this.userInfo.userWallet.balanceSumTwo = add([this.userInfo.userWallet.balanceTwo, this.userInfo.userWallet.balanceTwoGive])
          this.userInfo.userWallet.balanceSumThree = add([this.userInfo.userWallet.balanceThree, this.userInfo.userWallet.balanceThreeGive])
          this.userInfo.userWallet.balanceSumFour = add([this.userInfo.userWallet.balanceFour, this.userInfo.userWallet.balanceFourGive])
          if(data.data.userRemarkList.length > 0) {
            this.showUserRemark = true
          }
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      }).catch(()=> {
      })
    },

    editUserLog() {
      Dialog.open({
        title: '用户备注',
        component: UserRemarkDialog,
        data: {
          id: this.userId,
          width: '1100px'
        },
        close: () => {
          this.userInfo['userRemarkList'] = JSON.parse(sessionStorage.getItem('userLog'));
          if(this.userInfo.userRemarkList.length > 0) {
            this.showUserRemark = true
          }
        }
      })
    },

    editUserDialog(idx, row) {
      let _title = '';
      let userForm = {}
      if (idx > -1) {
        _title = '修改资料'
        userForm = Object.assign({}, row);
        // console.log(userForm)
      }else {
        _title = '创建新客'
        // console.log(userForm)
      }
      Dialog.open({
        title: _title,
        component: UserDialog,
        data: {
          userForm: userForm,
          ids: idx,
          width: '700px',
        },
        confirm: (result) => {
          this.getPage()
          this.$emit('confirm')
        }
      })
    },

    openDialog() {
      // let walletDetail = {}
      // Dialog.open({
      //   title: '',
      //   component: SearchInfoDialog,
      //   data: {
      //     userForm: this.userInfo,
      //     walletDetail: walletDetail,
      //     width: '700px'
      //   },
      //   confirm: () => {
      //     this.getPage()
      //     this.$emit('confirm')
      //   }
      // })
      Dialog.open({
        title: '充值抵扣记录',
        component: PayDeductionListDialog,
        data: {
          id: this.userId,
          userForm: this.userInfo,
          width: '1100px'
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getPage()
          }
          sessionStorage.removeItem('recordState')
        }
      })
    },


    petListDialog(row) {
      let editable = true
      // let visibleShopList = JSON.parse(sessionStorage.getItem('ownShopList')).filter(item => item.isEdit == 1)
      // if(visibleShopList.every(item => item.id != this.userInfo.shopId)) {
      //   editable = false
      // }
      Dialog.open({
        title: '猫咪信息',
        component: PetListDialog,
        data: {
          userForm: row,
          petList: row.petList,
          editable: editable,
          width: '1100px',
          userId: this.userId,
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getPage()
            // this.$emit('confirm')
          }
          sessionStorage.removeItem('recordState')
        }
      })
    },

    consumeListDialog() {
      Dialog.open({
        title: '消费单',
        component: ConsumeListDialog,
        data: {
          id: this.userInfo.id,
          width: '1100px',
          userForm: this.userInfo,
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getPage()
            // this.$emit('confirm')
          }
          sessionStorage.removeItem('recordState')
        }
      })
    },

    projectGiveList() {
      Dialog.open({
        title: '赠送项目',
        component: projectGiveListDialog,
        data: {
          userInfo: this.userInfo,
          width: '1100px',
        },
        close: () => {
        }
      })
    },

    openMedicalLis() {
      Dialog.open({
        title: '医疗金余额',
        component: medicalListDialog,
        data: {
          userId: this.userInfo.id,
          width: '1100px'
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getPage()
            // this.$emit('confirm')
          }
          sessionStorage.removeItem('recordState')
        }
      })
    }


  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>
.title {
  font-weight: bold;
  color: #303133;
}
.content-box {
  border: 0.1em solid #ebeef5;
  padding: 4px 16px;
  margin-top: 12px;
  /*cursor: pointer;*/
  font-size: 13px;
}
</style>
